import { StepConfig } from 'components/new-ui/composed/multistep-form/types';
import { ManifestFormFields, ManifestFormSteps } from './types';
import Manifest from './components/steps/Manifest';
import TransportDetails from './components/steps/TransportDetails';
import {
    manifestReferenceSchema,
    teamValidationSchema,
    transportDetailsValidationSchema,
} from './create-manifest.schemas';
import Team from './components/steps/Team';

export const getStepsConfig = (isAdmin: boolean, isUnderTeam: boolean): StepConfig<ManifestFormFields>[] => {
    const steps: StepConfig<ManifestFormFields>[] = [
        {
            key: ManifestFormSteps.MANIFEST,
            label: 'Manifest',
            validationSchema: manifestReferenceSchema,
            component: Manifest,
            skipAutoProgress: true,
        },
        {
            key: ManifestFormSteps.TRANSPORT_DETAILS,
            label: 'Transport Details',
            validationSchema: transportDetailsValidationSchema,
            component: TransportDetails,
        },
    ];

    if (isAdmin && !isUnderTeam) {
        steps.push({
            key: ManifestFormSteps.TEAM,
            label: 'Team',
            validationSchema: teamValidationSchema,
            component: Team,
        });
    }

    return steps;
};
